function isSameFn<T>(val: T, i: number, arr: T[]): boolean {
  return val === arr[0];
}

export function areAllSame<T>(input: T[]): boolean {
  return input.every(isSameFn);
}

export default areAllSame;
